export default __webpack_public_path__ + "static/media/correct_answer.5c2fe087.svg";